// extracted by mini-css-extract-plugin
export default {"header":"AgentCardHeader_header__r-Rn-","name":"AgentCardHeader_name__Y-Vx1","avatar":"AgentCardHeader_avatar__YqMCV","subheader":"AgentCardHeader_subheader__7OeDE"};